/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MeterUsageBreakdown,
  MeterUsageBreakdown$inboundSchema,
} from "./meterusagebreakdown.js";
import {
  MeterUsageBucket,
  MeterUsageBucket$inboundSchema,
} from "./meterusagebucket.js";
import {
  MeterUsageWindow,
  MeterUsageWindow$inboundSchema,
} from "./meterusagewindow.js";

export const Family = {
  AgentSessionStorage: "agent_session_storage",
  McpBandwidth: "mcp_bandwidth",
  RiskContentScans: "risk_content_scans",
} as const;
export type Family = ClosedEnum<typeof Family>;

export const Unit = {
  Stokens: "stokens",
  Bytes: "bytes",
} as const;
export type Unit = ClosedEnum<typeof Unit>;

export type MeterUsageResponse = {
  /**
   * Trailing twelve billing-cycle date windows
   */
  billingCycles: Array<MeterUsageWindow>;
  breakdown: MeterUsageBreakdown;
  /**
   * Dense UTC daily ordinary usage buckets, including in-progress days
   */
  buckets: Array<MeterUsageBucket>;
  family: Family;
  measurementMethod: string;
  /**
   * Retrieval timestamp, not an ingestion watermark
   */
  queriedAt: Date;
  /**
   * Exact integer ordinary usage period total as a decimal string
   */
  total: string;
  unit: Unit;
  window: MeterUsageWindow;
};

/** @internal */
export const Family$inboundSchema: z.ZodMiniEnum<typeof Family> = z.enum(
  Family,
);

/** @internal */
export const Unit$inboundSchema: z.ZodMiniEnum<typeof Unit> = z.enum(Unit);

/** @internal */
export const MeterUsageResponse$inboundSchema: z.ZodMiniType<
  MeterUsageResponse,
  unknown
> = z.pipe(
  z.object({
    billing_cycles: z.array(MeterUsageWindow$inboundSchema),
    breakdown: MeterUsageBreakdown$inboundSchema,
    buckets: z.array(MeterUsageBucket$inboundSchema),
    family: Family$inboundSchema,
    measurement_method: z.string(),
    queried_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    total: z.string(),
    unit: Unit$inboundSchema,
    window: MeterUsageWindow$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "billing_cycles": "billingCycles",
      "measurement_method": "measurementMethod",
      "queried_at": "queriedAt",
    });
  }),
);

export function meterUsageResponseFromJSON(
  jsonString: string,
): SafeParseResult<MeterUsageResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MeterUsageResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MeterUsageResponse' from JSON`,
  );
}
